import React, { useState } from 'react';
import { PartnerImage } from '../../types/api';
import { getImageUrl } from '../../utils/image';

interface VenueGalleryProps {
  images: PartnerImage[];
  onEdit: () => void;
}

export const VenueGallery: React.FC<VenueGalleryProps> = ({ images, onEdit }) => {
  const [opened, setOpened] = useState<string | null>(null);

  return (
    <section className="qp-panel">
      <header className="qp-panel-head">
        <h2 className="qp-label">Фотогалерея · {images.length}</h2>
        <button type="button" className="qp-btn qp-btn--outline qp-btn--sm" onClick={onEdit}>
          Загрузить
        </button>
      </header>

      {images.length > 0 ? (
        <div className="qp-gallery">
          {images.map((image, index) => {
            const url = getImageUrl(image.url) || image.url;
            return (
              <button
                key={image.id}
                type="button"
                className="qp-gallery-cell"
                aria-label={`Открыть фото ${index + 1}`}
                onClick={() => setOpened(url)}
              >
                <img src={url} alt="" loading="lazy" />
              </button>
            );
          })}
        </div>
      ) : (
        <div className="qp-gallery">
          {/* Три пустые ячейки вместо текста «нет фото»: место под
              галерею видно сразу, и понятно, куда нажимать. */}
          {[0, 1, 2].map((index) => (
            <button key={index} type="button" className="qp-gallery-cell" onClick={onEdit}>
              + ФОТО
            </button>
          ))}
        </div>
      )}

      {opened && (
        <div
          className="qp-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label="Просмотр фото"
          onClick={() => setOpened(null)}
        >
          <img src={opened} alt="" onClick={(event) => event.stopPropagation()} />
        </div>
      )}
    </section>
  );
};
